import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InboxIcon from "@mui/icons-material/Inbox";

export default function NoRowsOverlay({
    title,
    subtitle,
}) {
    return (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 180,
                textAlign: "center",
                px: 2,
            }}
        >
            <Box sx={{ p: 1.5, bgcolor: "var(--primaryLight)", borderRadius: 3 }}><InboxIcon sx={{ fontSize: 26, color: "primary.main" }} /></Box>
            <Typography variant="subtitle1" fontWeight={600} mt={1} color="text.secondary">
                {title || "No records to display"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {subtitle || "Try adjusting your search or filters."}
            </Typography>
        </Box>
    );
}
